export default class DtoInstallationsAssociatedEvents {
    constructor(obj = {}) {
        this.installation = obj.installation // Seq[InstallationEvent]
        this.piezometry = obj.piezometry // Seq[PiezometryEvent]
        this.hydrometry = obj.hydrometry // Seq[HydrologicalEvent]
        this.pluvimetry = obj.pluvimetry // Seq[PluviometryEvent]
    }
}